export var WELCOME_MESSAGE = {
    title: "Welcome to {{appName}}! We\u2019re glad you\u2019re here.",
    desc: "{{appName}} is your tool to create, take, and manage polls.",
    actions: {
        primary: {
            label: "Sign In",
            target: "sign-in",
        },
        secondary: {
            label: "Sign Up",
            target: "register",
        },
        tertiary: {
            label: "Learn more about {{appName}}",
            target: "info:{{appName}}",
        },
    },
};
//# sourceMappingURL=Welcome.js.map